import { TimetableRequestParams } from "../types";

export const fetcher = (params: TimetableRequestParams) => {
  const url = new URL(
    "/wp-json/sealines/v1/live-timetable",
    window.location.origin
  );

  url.searchParams.append("from", params.from);
  url.searchParams.append("to", params.to);
  url.searchParams.append("fromDate", params.fromDate.toISOString());
  url.searchParams.append("toDate", params.toDate.toISOString());

  return fetch(url).then((res) => (res.ok ? res.json() : Promise.reject(res)));
};
